import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

export const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Evita ejecutar getAuth en SSR
export let auth = null;
if (typeof window !== "undefined") {
  auth = getAuth(app);
  // Si querés que el mail de Firebase salga en el idioma del navegador:
  auth.useDeviceLanguage?.(); // opcional
}
